import { render, staticRenderFns } from "./ProductsOverviewMedia.vue?vue&type=template&id=5318221e&scoped=true&"
import script from "./ProductsOverviewMedia.vue?vue&type=script&lang=js&"
export * from "./ProductsOverviewMedia.vue?vue&type=script&lang=js&"
import style0 from "./ProductsOverviewMedia.vue?vue&type=style&index=0&id=5318221e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318221e",
  null
  
)

export default component.exports